export interface ISampleMetric {
  timeOfReceipt: string;
  value: number;
}
